<script>
import { VRadio } from 'vuetify/lib'
import { mergeListeners } from 'vuetify/lib/util/mergeData'
import { prevent } from 'vuetify/lib/mixins/selectable/index'
import { getSlot } from 'vuetify/lib/util/helpers'

export default {
  name: 'ERadio',
  extends: VRadio,
  props: {
    detail: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes() {
      return {
        'e-radio': true,
        ...VRadio.options.computed.classes.call(this),
        'v-radio--is-focused': false,
        'v-radio--is-disabled': false,
        'e-radio--is-focused': this.isFocused,
        'e-radio--is-disabled': this.isDisabled,
      }
    },
  },
  methods: {
    genContent() {
      return this.$createElement(
        'div',
        {
          staticClass: 'e-radio__content',
        },
        [this.genLabel(), this.genDetail()]
      )
    },
    genLabel() {
      if (!this.label) return null
      return this.$createElement(
        'label',
        {
          on: {
            // Label shouldn't cause the input to focus
            click: prevent,
          },
          attrs: {
            for: this.computedId,
          },
          staticClass: 'e-radio__label',
        },
        this.label
      )
    },
    genDetail() {
      if (!this.detail) return null
      return this.$createElement(
        'span',
        {
          staticClass: 'e-radio__detail',
        },
        getSlot(this, 'detail') || this.detail
      )
    },
    genRadio() {
      const { title, ...radioAttrs } = this.attrs$
      return this.$createElement(
        'div',
        {
          staticClass: 'v-input--selection-controls__input',
        },
        [
          this.$createElement('span', {
            staticClass: 'e-radio__checkmark',
            class: {
              'e-radio__checkmark--checked': this.isActive,
            },
          }),
          this.genInput({
            name: this.computedName,
            value: this.value,
            ...radioAttrs,
          }),
        ]
      )
    },
  },
  render(h) {
    const data = {
      staticClass: 'v-radio',
      class: this.classes,
      on: mergeListeners(
        {
          click: this.onChange,
        },
        this.listeners$
      ),
      attrs: {
        title: this.attrs$.title,
      },
    }
    return h('div', data, [this.genRadio(), this.genContent()])
  },
}
</script>
